module.exports = __webpack_public_path__ + "assets/img/1.9bd92a55.jpg";